import React from "react";
import { BrowserRouter, Routes, Route } from "react-router";
import { Home } from "../components/Home";
import { About } from "../components/About";
import { Curriculum } from "../components/Curriculum";
// import { Header } from "../components/layouts/Header";
import { Portafolio } from "../components/Portafolio";
import { Contact } from "../components/Contact";
// import { Blog } from "..components/Blog";
// import { Footer } from "../components/layouts/Footer";
import { Aside } from "../components/layouts/Aside";
import { Blog } from "../components/Blog";

export const RoutersPrincipal = () => {
  return (
    <BrowserRouter>
      <div className="layout">
        {/* HEADER Y NAVEGATION */}

        <Aside />

        {/* CONTENIDO CENTRAL  */}
        <main className="layout__content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/inicio" element={<Home />} />
            <Route path="/sobre-mi" element={<About />} />
            <Route path="/curriculum" element={<Curriculum />} />
            <Route path="/portafolio" element={<Portafolio />} />
            {/* <Route path="/blog" element={<Blog />} /> */}
            <Route path="/blog" element={<Blog />} />
            <Route path="/contactos" element={<Contact />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
};
